import Pusher from "pusher-js";

import firebase from "js/firebase";
import { isDevelopment, pusherKey, pusherCluster } from "js/config";

let pusher;
function getPusher() {
    if (window.disablePusher) {
        return null;
    }

    if (!pusher) {
        if (isDevelopment) {
            Pusher.logToConsole = true;
        }

        pusher = new Pusher(pusherKey, {
            cluster: pusherCluster,
            authEndpoint: "/pusher/authenticate",
            auth: {
                headers: {}
            }
        });
    }

    return pusher;
}

async function _subscribe(channelId, authHeaders = {}) {
    const pusher = getPusher();
    if (!pusher) {
        return null;
    }

    // Resetting auth headers
    pusher.config.auth.headers = {};

    // Setting user token
    if (firebase.auth().currentUser) {
        const idToken = await firebase.auth().currentUser.getIdToken();
        pusher.config.auth.headers.Authorization = `Bearer ${idToken}`;
    }

    // Setting additional auth headers (if passed)
    Object.entries(authHeaders).forEach(([key, value]) => {
        pusher.config.auth.headers[key] = value;
    });

    // Will make sure subscription succeeded
    const channel = await new Promise((resolve, reject) => {
        const channel = pusher.subscribe(channelId);
        channel.bind("pusher:subscription_error", err => reject(err));
        channel.bind("pusher:subscription_succeeded", () => resolve(channel));
    });

    return channel;
}

// Subscribe has to be chained to make sure we never change pusher auth headers when there's an
// auth request pending
let subscribeChain = Promise.resolve();
function subscribe(...args) {
    return new Promise((resolve, reject) => {
        subscribeChain = subscribeChain.then(() => _subscribe(...args).then(resolve).catch(reject));
    });
}

module.exports = { subscribe };
